import { api } from './api.js';

/**
 * Serviço de billing e pagamentos
 */
export const billingService = {
    /**
     * Cria uma sessão de checkout do Stripe
     * @param {string} lookupKey - Chave do plano (ex: 'alzan.vet.premium')
     * @param {string} customerEmail - Email do cliente
     * @param {number} entityId - ID da entidade
     * @param {string} couponId - ID do cupom de desconto (opcional)
     * @param {string} successUrl - URL de sucesso (opcional)
     * @param {string} cancelUrl - URL de cancelamento (opcional)
     * @param {number} weight - Peso do plano (opcional)
     * @param {string} planTitle - Título do plano (opcional)
     * @returns {Promise<{success: boolean, session_id: string, url: string}>}
     */
    async createCheckoutSession(lookupKey, customerEmail, entityId = null, couponId = null, weight = null, planTitle = null, successUrl = null, cancelUrl = null) {
        try {
            const baseUrl = window.location.origin;

            const response = await api.post('/v1/api/billings/stripe/create-checkout-session', {
                lookup_key: lookupKey,
                success_url: successUrl || `${baseUrl}/success?session_id={CHECKOUT_SESSION_ID}`,
                cancel_url: cancelUrl || `${baseUrl}/dashboard`,
                customer_email: customerEmail,
                coupon: couponId,
                metadata: { entityId: entityId, weight: weight, planTitle: planTitle },
            });

            if (response.data.success) {
                return {
                    success: true,
                    sessionId: response.data.session_id,
                    url: response.data.url,
                };
            } else {
                throw new Error('Erro ao criar sessão de checkout');
            }
        } catch (error) {
            console.error('Erro ao criar checkout:', error);
            throw {
                success: false,
                message: error.response?.data?.msg || error.response?.data?.message || error.message || 'Erro ao processar pagamento',
            };
        }
    },
};
